import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/media-has-caption */
import TargetResultsFAQ from "../TargetResultsPage/TargetResultsFaq";
import styles from "./styles.module.scss";
import TargetAdvantages from "./TargetAdvantages";
import TargetBanner from "./TargetBanner";
import TargetCustomers from "./TargetCustomers";
import TargetNavBar from "./TargetNavBar";
import TargetPreview from "./TargetPreview";
import TargetPromo from "./TargetPromo";
import TargetTeam from "./TargetTeam";
import TargetUnderstandSystem from "./TargetUnderstandSystem";
import TargetHowItWorks from "./TargetHowItWorks";
import { Footer } from "Root/checkout/components/Footer";
const TargetLandingPage = () => (_jsxs("div", { className: styles.target, children: [_jsx(TargetNavBar, {}), _jsx(TargetBanner, {}), _jsx(TargetHowItWorks, {}), _jsx(TargetAdvantages, {}), _jsx(TargetPreview, {}), _jsx(TargetUnderstandSystem, {}), _jsx(TargetTeam, {}), _jsx(TargetCustomers, {}), _jsx(TargetPromo, {}), _jsx(TargetResultsFAQ, {}), _jsx(Footer, { userLoggedIn: false })] }));
export default TargetLandingPage;
